import Clarity from '@microsoft/clarity';

// Session cookie Clarity uses to decide whether a visit continues the previous recording.
// `_clck` (the visitor id) is deliberately left alone so unique-visitor metrics stay intact.
const SESSION_COOKIE_NAME = '_clsk';

let initialized = false;

const dropSessionCookie = () => {
  document.cookie = `${SESSION_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};

type InitializeOptions = {
  /**
   * Whether dropping the session cookie is safe. Another tab already recording an order shares the
   * cookie, so resetting it there would corrupt that tab's recording.
   */
  canStartNewSession?: boolean;
};

const initialize = (
  projectId?: string | null,
  orderId?: string,
  { canStartNewSession }: InitializeOptions = {},
) => {
  if (initialized || !projectId) {
    return;
  }

  // Consecutive orders opened in one browser would otherwise continue the same recording.
  if (canStartNewSession) {
    dropSessionCookie();
  }

  Clarity.init(projectId);
  initialized = true;

  // SCI has no consent banner, so consent is never asked for — ad storage is denied explicitly.
  Clarity.consentV2({ ad_Storage: 'denied', analytics_Storage: 'granted' });

  // Makes recordings searchable by order id in the dashboard.
  if (orderId) {
    Clarity.identify(orderId, orderId);
  }
};

export const clarityUtils = {
  initialize,
};
